import {createReducer} from '@reduxjs/toolkit';

import {
  setIsBasketRecommendationLoadingAction,
  setBasketRecommendationsAction,
  setRecommendationsComplexPromotionAction
} from 'store/actions/basket-action';
import {ReduxRecommendationsState} from 'types';

const initialState: ReduxRecommendationsState = {
  recommendations: {
    actualCount: 0,
    algorithm: '',
    products: [],
    recommendationType: '',
    totalCount: 0,
    personalized: false
  },
  isLoading: false,
  complexPromotion: {}
};

const RecommendationsReducer = createReducer(initialState, (builder) => {
  builder.addCase(setIsBasketRecommendationLoadingAction, (state, action) => {
    return {
      ...state,
      isLoading: action?.payload
    };
  });
  builder.addCase(setBasketRecommendationsAction, (state, action) => {
    return {
      ...state,
      isLoading: false,
      recommendations: action?.payload
    };
  });
  builder.addCase(setRecommendationsComplexPromotionAction, (state, action) => {
    return {
      ...state,
      complexPromotion: action?.payload
    };
  });
});

export default RecommendationsReducer;
